@if (fieldModels.length) {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{ getCompName() }}</mat-panel-title>
    </mat-expansion-panel-header>
    @if (compTypeModel) {
      <div class="row" [formGroup]="formGroup">
        <mat-form-field class="comp-select">
          <mat-label>{{ compTypeModel.label }}</mat-label>
          <mat-select [formControlName]="compTypeModel.key" (selectionChange)="changeComponent($event.value)">
            @for (opt of compTypeModelOptions; track opt) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @for (fieldModel of fieldModels; track trackByFieldKey($index, fieldModel)) {
      <div class="form-row">
        <pub-component-editor-field [fieldModel]="fieldModel" [form]="formGroup"></pub-component-editor-field>
      </div>
    }
  </mat-expansion-panel>
}
